import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import Link from 'next/link';
import styles from '@components/chat/chatDetail/messageList/index.module.scss';
import AdminMessage from '@domain/constant/chat/AdminMessage';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface DeadlineMessageProps {
  message: Message;
}

const DeadlineMessage = ({ message }: DeadlineMessageProps) => {
  const customData = message.data?.customData as unknown as AdminMessage[];
  const companyName = customData?.[0]?.companyName || null;

  const listEl = customData?.map((item, index) => {
    return (
      <span key={index} className={cx('itemArea')}>
        <span>■</span>
        <span className={cx('itemWrap')}>
          <span className={cx('jobPostingName')}>{item.jobPostingName}</span>
          {item.recruitmentUrl && (
            <Link href={item.recruitmentUrl} legacyBehavior>
              <a className={cx('link')} target={'_blank'}>
                자세히 보기
              </a>
            </Link>
          )}
        </span>
      </span>
    );
  });

  {
    /* 복사하기를 위한 id */
  }
  return (
    <span id={message.id} className={cx('message')}>
      <em className={cx('em')}>[D-3] 입사지원 마감 안내 ⏰</em>
      <br />곧 마감되는 {companyName} 채용공고가 있어요. 서둘러 지원을 마무리해주세요!
      {listEl?.length > 0 && (
        <>
          <br />
          <br />
          {listEl}
        </>
      )}
    </span>
  );
};

export default DeadlineMessage;
